export const MY_PAY_WAITLIST_STATUS_RETURNED =
  'MY_PAY_WAITLIST_STATUS_RETURNED';

export const myPayWaitlistStatusReturned = payload => dispatch =>
  dispatch({
    type: MY_PAY_WAITLIST_STATUS_RETURNED,
    payload,
  });
